import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";

const ExcelDownloader = ({ data, fileName = "Merchant_Settlement", role }) => {
  const handleDownload = () => {
    if (!data || data.length === 0) {
      toast.error("No data available to download");
      return;
    }

    const formattedData = data.map((item) => {
      const paidAmount = item.status ? Number(item.paidAmount) : 0;
      const base = {
        "Total Settlement Amount": `₹ ${item.settlementAmount}`,
        "Wallet Amount": `₹ ${item.status ? Number(item.paidAmount).toFixed(2) : "0.00"}`,
        "Rolling Reserve Amount": `₹ ${item.rrAmount}`,
       "Settlement Time Range": item.settlementTimeRange,
       "Status": item.status
  ? item.settlementTimeRange
      .split("Z-")
      .map((d, i) => {
        const date = i === 0 ? d + "Z" : d;
        const parsed = new Date(date);
        return isNaN(parsed)
          ? "N/A"
          : parsed.toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
              timeZone: "Asia/Kolkata",
            });
      })
      .join(" to ")
  : "N/A",

        "Settled Date": new Date(item.settledDate).toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
          timeZone: "Asia/Kolkata",
        }),
      };

      if (role !== "admin") {
        base["Merchant Name"] = item.name;
        base["Fund Difference"] = `₹ ${(Number(item.settlementAmount || 0) - paidAmount).toFixed(2)}`;
      }

      return base;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Merchant Settlement");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}_${new Date().toISOString()}.xlsx`);
  };

  return (
    <button className="btn-excel" onClick={handleDownload}>
      Download Excel
    </button>
  );
};

export default ExcelDownloader;
